import * as React from 'react';

const H1ChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="h1-chunky_svg__eds-icon--h2-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="h1-chunky_svg__eds-icon--h1-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 12H5V6H3v14h2v-6h7v6h2V6h-2z"
        />
        <path
            id="h1-chunky_svg__eds-icon--h1-chunky_number"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 10V4h-1c-.3.3-1 .4-1 .4v1.2s1-.1 1-.3V10h-1v1h3v-1h-1z"
        />
    </svg>
);

H1ChunkySvg.displayName = 'H1ChunkySvg';
export default H1ChunkySvg;
